<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
    >
        <g clip-path="url(#clip0_183_580)">
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M9.25 6.58334V9.16667C9.25 9.58088 9.58579 9.91667 10 9.91667C10.4142 9.91667 10.75 9.58088 10.75 9.16667V6.58334H14.7222C15.2615 6.58334 15.7328 6.87328 15.9893 7.30556L15.9947 7.31644C16.0064 7.34006 16.0192 7.3628 16.033 7.38461C16.1362 7.58585 16.1944 7.81394 16.1944 8.05557V14.7222C16.1944 15.0845 16.0569 15.4174 15.8236 15.6848C15.5514 15.997 15.5837 16.4708 15.8959 16.743C16.2081 17.0153 16.6818 16.9829 16.9541 16.6708C17.4031 16.156 17.6944 15.4799 17.6944 14.7222V8.05557C17.6944 7.5242 17.5549 7.02526 17.3105 6.59347L15.7286 3.40245C15.2266 2.39107 14.1954 1.75 13.0655 1.75H6.93442C5.80459 1.75 4.77348 2.39074 4.27151 3.40212L2.68489 6.60163C2.4433 7.03154 2.30554 7.52755 2.30554 8.05557V14.7222C2.30554 16.3629 3.63553 17.6945 5.27776 17.6945H10.8333C11.2475 17.6945 11.5833 17.3587 11.5833 16.9445C11.5833 16.5302 11.2475 16.1945 10.8333 16.1945H5.27776C4.46444 16.1945 3.80554 15.5349 3.80554 14.7222V8.05557C3.80554 7.81135 3.86504 7.58097 3.97035 7.37815C3.98284 7.35801 3.99449 7.33709 4.00523 7.31542L4.00715 7.31155C4.26279 6.87596 4.73602 6.58334 5.27776 6.58334H9.25ZM6.93442 3.25C6.37537 3.25 5.86425 3.56703 5.61512 4.06899L5.10979 5.08801C5.16539 5.08491 5.22139 5.08334 5.27776 5.08334H9.25V3.25H6.93442ZM14.89 5.088L14.3848 4.06899C14.1357 3.56703 13.6246 3.25 13.0655 3.25H10.75V5.08334H14.7222C14.7785 5.08334 14.8345 5.08491 14.89 5.088Z"
                fill="#8E8E93"
            />
            <path
                d="M13.6111 12.8611C14.0253 12.8611 14.3611 13.1969 14.3611 13.6111V16.6667C14.3611 17.0809 14.0253 17.4167 13.6111 17.4167C13.1969 17.4167 12.8611 17.0809 12.8611 16.6667V13.6111C12.8611 13.1969 13.1969 12.8611 13.6111 12.8611Z"
                fill="#8E8E93"
            />
            <path
                d="M14.4444 19.1667C14.4444 19.6269 14.0713 20 13.6111 20C13.1509 20 12.7778 19.6269 12.7778 19.1667C12.7778 18.7064 13.1509 18.3333 13.6111 18.3333C14.0713 18.3333 14.4444 18.7064 14.4444 19.1667Z"
                fill="#8E8E93"
            />
        </g>
        <defs>
            <clipPath id="clip0_183_580">
                <rect width="20" height="20" fill="white" />
            </clipPath>
        </defs>
    </svg>
</template>
